import { OkxBTCWallet } from '@/utils/wallet/providers/okx-btc';

import { WalletBase } from './WalletBase';
import { PetraWallet } from './providers/aptos';
import { BitcoinWallet } from './providers/bitcoin';
import { EvmWallet } from './providers/evm';
import { ParticleWallet } from './providers/particle';
import { PhantomWallet } from './providers/solana';
import { UnisatWallet } from './providers/unisat';
import { ExtendedWalletType, ProviderType, WalletType } from './types';

export abstract class WalletFactory {
  private static instances: Record<string, WalletBase> = {};
  static async getWallet(type: ProviderType, userAddress?: string): Promise<WalletBase> {
    if (!this.instances[type]) {
      let WalletClass;
      switch (type) {
        case WalletType.EVM:
          WalletClass = EvmWallet;
          break;
        case WalletType.BITCOIN:
          WalletClass = BitcoinWallet;
          break;
        case ExtendedWalletType.UNISAT:
          WalletClass = UnisatWallet;
          break;
        case ExtendedWalletType.OKXBTC:
          WalletClass = OkxBTCWallet;
          break;
        case WalletType.SOLANA:
          WalletClass = PhantomWallet;
          break;
        case WalletType.TON:
          WalletClass = (await import('./providers/ton')).TonWallet;
          break;
        case WalletType.APTOS:
          WalletClass = PetraWallet;
          break;
        case WalletType.PARTICLE:
          WalletClass = ParticleWallet;
          break;
        case WalletType.OKX:
          WalletClass = (await import('./providers/okx')).OkxWallet;
          break;
        case WalletType.StarkNet:
          WalletClass = (await import('./providers/starknet')).StarkNetWallet;
          break;
        case WalletType.WALLETCONNECT:
          WalletClass = (await import('./providers/walletconnect')).WalletConnectWallet;
          break;
        case WalletType.Cardano:
          WalletClass = (await import('./providers/ada')).ADAWallet;
          break;
        case WalletType.Coinbase:
          WalletClass = (await import('./providers/coinbasewallet')).CoinbaseWallet;
          break;
        default:
          throw new Error('Unsupported wallet type');
      }

      if (!WalletClass) {
        throw new Error('Unsupported wallet type');
      }
      this.instances[type] = new WalletClass(type, userAddress);
    }
    return this.instances[type];
  }
}
